import { Injectable } from '@angular/core';
import { CrudService } from '../crud.service';
import { BookmarkCategory } from '../../models/bookmark-category';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookmarkCategoryService extends CrudService<BookmarkCategory> {
  protected basePath = 'bookmarkcategory'; // Specific for BookmarkService
  public instanceType = 'bookmarkcategory'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Atomically adds/removes bookmark ids on a category's `bookmarks` array
   * server-side, instead of sending a (possibly outdated) full copy of it.
   *
   * @param {string} categoryId - The category to change.
   * @param {{ add?: string[]; remove?: string[] }} changes - Bookmark ids to add/remove.
   * @return {Promise<BookmarkCategory>} The updated category.
   */
  updateBookmarkAssignments(
    categoryId: string,
    changes: { add?: string[]; remove?: string[] }
  ): Promise<BookmarkCategory> {
    return lastValueFrom(
      this.http.put<BookmarkCategory>(
        `${this.getBaseUrl()}/updateBookmarks/${categoryId}`,
        changes
      )
    );
  }
}
